export function createBiDirectionalObject(obj) {
    let biDirectionalObj = {};

    for (let key in obj) {
        biDirectionalObj[key] = obj[key];
        biDirectionalObj[obj[key]] = key;
    }

    return biDirectionalObj;
}
